import React, { ChangeEvent } from "react"
import { TextFieldProps } from "@mui/material/TextField"
import { FormInputState } from "../../utils/validations"
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from "@mui/material"

type InputProps = TextFieldProps & {
  inputHandler?: React.FormEventHandler<HTMLDivElement>
  rows?: number
  values: string[]
  value: string[]
}

export const FormMultiSelect = ({
  fieldName,
  fieldId,
  inputs,
  inputHandler,
  values,
  fullLabel,
}: {
  inputs: Record<string, FormInputState>
  fieldName: string
  fullLabel?: string
  fieldId: string
  values: string[]

  inputHandler: (
    e: ChangeEvent<HTMLInputElement> | FocusEvent<HTMLInputElement>
  ) => void
}) => {
  const field = inputs[fieldName] as FormInputState
  return (
    <MultiSelectStyle
      id={fieldId}
      value={field.value}
      values={values}
      label={fullLabel ?? field.label}
      name={fieldName}
      variant="outlined"
      required={field.validation?.some(e => e.type === "required")}
      onChange={inputHandler}
      error={!!field.error}
      helperText={field.error}
    />
  )
}

export const MultiSelectStyle = ({
  value,
  label,
  name,
  values,
  onChange,
  helperText,
  error,
}: InputProps) => {
  const [state, setState] = React.useState<string[]>(value ?? [])
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let res = []
    const vals = state
    if (vals.includes(event.target.name)) {
      //remove
      res = vals.filter(s => s !== event.target.name)
    } else {
      res = [event.target.name, ...vals]
    }

    setState(res)

    if (onChange) {
      onChange({ target: { name: name!, value: res } } as any)
    }
  }

  return (
    <>
      {label && (
        <>
          <FormLabel component="legend">{label}</FormLabel>
          <FormGroup>
            {values.map((c: string) => (
              <FormControlLabel
                key={c}
                control={
                  <Checkbox
                    checked={state.includes(c)}
                    onChange={handleChange}
                    name={c}
                  />
                }
                label={c}
              />
            ))}
            {error && (
              <FormHelperText className="error">{helperText}</FormHelperText>
            )}
          </FormGroup>
        </>
      )}
    </>
  )
}
